<template>
  <div class="container center">
        <h1 class="loadingText">{{loadingString}}</h1>
        <div class="progress primary-bg">
            <div class="indeterminate"></div>
        </div>
        <h6 class="loadingText">Loading</h6>
  </div>
</template>

<script>

export default {
    name: "Loading",
    props: ['loadingString']
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (prefers-color-scheme: dark) {
    .progress .indeterminate {
        background-color: #999;
    }

    .loadingText{
        color: white;
    }

 }

 @media (prefers-color-scheme: light) {
    .progress .indeterminate {
        background-color: #9fa8da;
    }

    .loadingText{
        color: black;
    }

 }


</style>


